import apiFetch from '../apiFetch'

export default function (token, repairshop) {
  return apiFetch({ endPoint: `RepairShop/${repairshop.repairshopId}`, method: 'DELETE', body: null, token: token })
}
